import React from 'react'
import { useState, useEffect } from 'react';
import { jwtDecode } from "jwt-decode";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BASEURL } from '../../constants';
import { useNavigate } from "react-router-dom";
import CourseCard from '../Global/CourseCard/CourseCard';


const TeacherHome = () => {
  const [recentCourses, setRecentCourses] = useState([]);

  const token = localStorage.getItem('auth');
  const decoded = jwtDecode(token);
  const firstName = decoded.first_name;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllCourses = async () => {
      const userId = localStorage.getItem('auth');

      if (userId) {
        const response = await axios.post(`${BASEURL}/api/fetch-courses`, {
          user_id: userId,
        });

        const courseData = response.data.courseData;
        const draftCourses = courseData.filter(course => (course.verify_status === 'not verified' && course.course_status === 'incompleted' && course.publish_status === 'unpublished')).slice(0,4);

        setRecentCourses(draftCourses);
      }
    }

    fetchAllCourses();
  }, [])

  const courseCardClickHandler = (courseId) => {
    navigate(`/course-builder/${courseId}`)
  }

  return (
    <section className='h-full w-full'>
      <div className='flex justify-between p-6'>
        <div className='font-bold text-xl'>
          Overview
        </div>
        <div className='flex gap-2 items-center'>
          <span className='text-customPrimaryPurple text-base font-normal'>
            View dashboard
          </span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.53 11.4699C20.6705 11.6105 20.7494 11.8012 20.7494 11.9999C20.7494 12.1987 20.6705 12.3893 20.53 12.5299L14.53 18.5299C14.4614 18.6036 14.3786 18.6627 14.2866 18.7037C14.1946 18.7447 14.0953 18.7667 13.9946 18.7685C13.8939 18.7703 13.7938 18.7518 13.7005 18.714C13.6071 18.6763 13.5222 18.6202 13.451 18.5489C13.3798 18.4777 13.3236 18.3929 13.2859 18.2995C13.2482 18.2061 13.2297 18.1061 13.2315 18.0054C13.2332 17.9047 13.2553 17.8054 13.2963 17.7134C13.3373 17.6214 13.3964 17.5386 13.47 17.4699L18.19 12.7499H4.00005C3.80114 12.7499 3.61037 12.6709 3.46972 12.5302C3.32907 12.3896 3.25005 12.1988 3.25005 11.9999C3.25005 11.801 3.32907 11.6102 3.46972 11.4696C3.61037 11.3289 3.80114 11.2499 4.00005 11.2499H18.19L13.47 6.52991C13.3964 6.46125 13.3373 6.37845 13.2963 6.28645C13.2553 6.19445 13.2332 6.09513 13.2315 5.99443C13.2297 5.89373 13.2482 5.7937 13.2859 5.70031C13.3236 5.60692 13.3798 5.52209 13.451 5.45087C13.5222 5.37965 13.6071 5.32351 13.7005 5.28579C13.7938 5.24807 13.8939 5.22954 13.9946 5.23132C14.0953 5.23309 14.1946 5.25514 14.2866 5.29613C14.3786 5.33712 14.4614 5.39622 14.53 5.46991L20.53 11.4699Z" fill="#382F8A" />
            </svg>
          </span>
        </div>

      </div>

      <div className='flex px-6 w-full gap-6 flex-wrap'>

        <div className='relative flex gap-4 shadow-md w-[264px] h-[80px] bg-white p-4 justify-start items-center overflow-hidden'>
          <div
            className='rounded-full p-4'
            style={{ backgroundColor: 'rgba(234, 133, 42, 0.10)' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4.60001 19.125C4.60001 18.4951 4.85023 17.891 5.29563 17.4456C5.74103 17.0002 6.34512 16.75 6.97501 16.75H19.8M4.60001 19.125C4.60001 19.7549 4.85023 20.359 5.29563 20.8044C5.74103 21.2498 6.34512 21.5 6.97501 21.5H19.8V2.5H6.97501C6.34512 2.5 5.74103 2.75022 5.29563 3.19562C4.85023 3.64102 4.60001 4.24511 4.60001 4.875V19.125Z"
                stroke="#F2994A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className='flex flex-col'>
            <div>Active Courses</div>
            <div className='text-2xl font-bold'>34</div>
          </div>

          {/* Background SVGs */}
          <div className='absolute w-[264px] h-[80px]'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-63px`,
                right: `-10px`,
                transform: `rotate(9deg)`,
                opacity: 0.2,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-53px`,
                right: `-10px`,
                transform: `rotate(5deg)`,
                opacity: 0.18,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-38px`,
                right: `-10px`,
                transform: `rotate(0deg)`,
                opacity: 0.16,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-16px`,
                right: `-20px`,
                transform: `rotate(-3deg)`,
                opacity: 0.14,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `3px`,
                right: `-30px`,
                transform: `rotate(-6deg)`,
                opacity: 0.12,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `22px`,
                right: `-40px`,
                transform: `rotate(-9deg)`,
                opacity: 0.1,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `43px`,
                right: `-50px`,
                transform: `rotate(-12deg)`,
                opacity: 0.08,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
          </div>
        </div>
        <div className='relative flex gap-4 shadow-md w-[264px] h-[80px] bg-white p-4 justify-start items-center overflow-hidden'>
          <div className='rounded-full p-4' style={{ backgroundColor: 'rgba(234, 133, 42, 0.10)' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.60001 19.125C4.60001 18.4951 4.85023 17.891 5.29563 17.4456C5.74103 17.0002 6.34512 16.75 6.97501 16.75H19.8M4.60001 19.125C4.60001 19.7549 4.85023 20.359 5.29563 20.8044C5.74103 21.2498 6.34512 21.5 6.97501 21.5H19.8V2.5H6.97501C6.34512 2.5 5.74103 2.75022 5.29563 3.19562C4.85023 3.64102 4.60001 4.24511 4.60001 4.875V19.125Z" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className='flex flex-col'>
            <div>In Progress</div>
            <div className='text-2xl font-bold'>34</div>
          </div>
          {/* Background SVGs */}
          <div className='absolute w-[264px] h-[80px]'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-63px`,
                right: `-10px`,
                transform: `rotate(9deg)`,
                opacity: 0.2,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-53px`,
                right: `-10px`,
                transform: `rotate(5deg)`,
                opacity: 0.18,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-38px`,
                right: `-10px`,
                transform: `rotate(0deg)`,
                opacity: 0.16,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-16px`,
                right: `-20px`,
                transform: `rotate(-3deg)`,
                opacity: 0.14,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `3px`,
                right: `-30px`,
                transform: `rotate(-6deg)`,
                opacity: 0.12,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `22px`,
                right: `-40px`,
                transform: `rotate(-9deg)`,
                opacity: 0.1,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `43px`,
                right: `-50px`,
                transform: `rotate(-12deg)`,
                opacity: 0.08,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
          </div>
        </div>
        <div className='relative flex gap-4 shadow-md w-[264px] h-[80px] bg-white p-4 justify-start items-center overflow-hidden'>
          <div className='rounded-full p-4' style={{ backgroundColor: 'rgba(234, 133, 42, 0.10)' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.60001 19.125C4.60001 18.4951 4.85023 17.891 5.29563 17.4456C5.74103 17.0002 6.34512 16.75 6.97501 16.75H19.8M4.60001 19.125C4.60001 19.7549 4.85023 20.359 5.29563 20.8044C5.74103 21.2498 6.34512 21.5 6.97501 21.5H19.8V2.5H6.97501C6.34512 2.5 5.74103 2.75022 5.29563 3.19562C4.85023 3.64102 4.60001 4.24511 4.60001 4.875V19.125Z" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className='flex flex-col'>
            <div>Active Learners</div>
            <div className='text-2xl font-bold'>34</div>
          </div>
          {/* Background SVGs */}
          <div className='absolute w-[264px] h-[80px]'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-63px`,
                right: `-10px`,
                transform: `rotate(9deg)`,
                opacity: 0.2,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-53px`,
                right: `-10px`,
                transform: `rotate(5deg)`,
                opacity: 0.18,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-38px`,
                right: `-10px`,
                transform: `rotate(0deg)`,
                opacity: 0.16,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-16px`,
                right: `-20px`,
                transform: `rotate(-3deg)`,
                opacity: 0.14,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `3px`,
                right: `-30px`,
                transform: `rotate(-6deg)`,
                opacity: 0.12,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `22px`,
                right: `-40px`,
                transform: `rotate(-9deg)`,
                opacity: 0.1,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `43px`,
                right: `-50px`,
                transform: `rotate(-12deg)`,
                opacity: 0.08,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
          </div>
        </div>
        
        <div className='relative flex gap-4 shadow-md w-[264px] h-[80px] bg-white p-4 justify-start items-center overflow-hidden'>
          <div className='rounded-full p-4' style={{ backgroundColor: 'rgba(234, 133, 42, 0.10)' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.60001 19.125C4.60001 18.4951 4.85023 17.891 5.29563 17.4456C5.74103 17.0002 6.34512 16.75 6.97501 16.75H19.8M4.60001 19.125C4.60001 19.7549 4.85023 20.359 5.29563 20.8044C5.74103 21.2498 6.34512 21.5 6.97501 21.5H19.8V2.5H6.97501C6.34512 2.5 5.74103 2.75022 5.29563 3.19562C4.85023 3.64102 4.60001 4.24511 4.60001 4.875V19.125Z" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className='flex flex-col'>
            <div>Avg. Time Spent</div>
            <div className='text-2xl font-bold'>34</div>
          </div>
          {/* Background SVGs */}
          <div className='absolute w-[264px] h-[80px]'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-63px`,
                right: `-10px`,
                transform: `rotate(9deg)`,
                opacity: 0.2,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-53px`,
                right: `-10px`,
                transform: `rotate(5deg)`,
                opacity: 0.18,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-38px`,
                right: `-10px`,
                transform: `rotate(0deg)`,
                opacity: 0.16,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `-16px`,
                right: `-20px`,
                transform: `rotate(-3deg)`,
                opacity: 0.14,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `3px`,
                right: `-30px`,
                transform: `rotate(-6deg)`,
                opacity: 0.12,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `22px`,
                right: `-40px`,
                transform: `rotate(-9deg)`,
                opacity: 0.1,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
            <svg

              xmlns="http://www.w3.org/2000/svg"
              width="152.965"
              height="198.668"
              viewBox="0 0 95 88"
              fill="none"
              style={{
                position: 'absolute',
                top: `43px`,
                right: `-50px`,
                transform: `rotate(-12deg)`,
                opacity: 0.08,
              }}
            >
              <path
                d="M137.006 86.312C107.069 51.2672 62.7179 16.2729 4.53174 15.3332L143.808 -35.5562L180.874 153.08C180.693 152.709 180.502 152.319 180.3 151.911C178.357 147.977 175.448 142.362 171.584 135.629C163.857 122.164 152.305 104.221 137.006 86.312Z"
                stroke="var(--Secondary-Colors-Main, #F2994A)"
                stroke-width="1.371"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className='flex justify-between items-center p-6'>
        <div className='font-semibold text-xl'>
          Recent Courses
        </div>
        <div className='font-bold text-sm text-customPrimaryPurple'>
          See All
        </div>
      </div>

      <div className='flex flex-wrap gap-6 px-6'>
        {
          recentCourses.length ? (
            <>
              {
                recentCourses.map((course, index) => (
                  <CourseCard type='draft' course={course} courseId={course.id} onClickHandler={courseCardClickHandler} />
                ))
              }
            </>
          ) : (
            <div>No recent courses</div>
          )
        }
      </div>
    </section>
  )
}

export default TeacherHome

